import React, { useState } from 'react';
import { validateDiscountCode } from '../../services/discountService';

const DiscountCodeTest = () => {
  const [code, setCode] = useState('FOUNDING2025');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const testValidation = async () => {
    setLoading(true);
    setError('');
    setResult(null);

    try {
      console.log('Testing discount code:', code);
      const validation = await validateDiscountCode(code);
      console.log('Validation result:', validation);
      setResult(validation);
    } catch (err) {
      console.error('Validation error:', err);
      setError(err.message || 'Unknown error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-xl font-bold mb-4">Discount Code Test</h2>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Test Discount Code:
          </label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter discount code"
          />
        </div>

        <button
          onClick={testValidation}
          disabled={loading || !code.trim()}
          className="w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed"
        >
          {loading ? 'Testing...' : 'Test Validation'}
        </button>

        {error && (
          <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            <strong>Error:</strong> {error}
          </div>
        )}

        {result && (
          <div className={`p-3 rounded border ${
            result.valid 
              ? 'bg-green-100 border-green-400 text-green-700' 
              : 'bg-red-100 border-red-400 text-red-700'
          }`}>
            <div className="font-semibold mb-2">
              {result.valid ? '✅ Valid Code' : '❌ Invalid Code'}
            </div>
            
            {result.valid ? (
              <div className="text-sm space-y-1">
                <div><strong>Discount:</strong> {result.discountAmount}% off</div>
                <div><strong>Type:</strong> {result.discountType}</div>
                <div><strong>Description:</strong> {result.discount?.description}</div>
              </div>
            ) : (
              <div className="text-sm">
                <strong>Error:</strong> {result.error}
              </div>
            )}
          </div>
        )}

        <div className="text-xs text-gray-500 space-y-1">
          <div><strong>Available codes:</strong></div>
          <div>• FOUNDING2025 (100% off)</div>
          <div>• EARLYBIRD2025 (100% off)</div>
          <div>• TESTER2025 (100% off)</div>
        </div>
      </div>
    </div>
  );
};

export default DiscountCodeTest;
